module.exports = __webpack_public_path__ + "static/media/resultunimarctres.40855dfb.png";